<template>
  <div class="gmf-loot-crate-open-container" v-if="lcType">
    <ItemRewards
      v-if="opened"
      :items="items"
      :title="t('opened.title')"
      :description="t('opened.description')"
      @close="closeModal"
      show3dAvatarStep
      :showConfetti="false"
    />
  </div>
</template>

<style>
.gmf-loot-crate-open-container {
  max-width: 80vw;
  width: 450px;
}

.gmf-close-loot-crate-btn-container {
  min-height: 40px;
}

.gmf-context .gmf-loot-crate-rewards {
  padding: 0;
}

.gmf-loot-crate-reward {
  padding: var(--gmf-p-4);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
</style>

<script>
import state from '@/state';
import ItemRewards from '@/components/Items/ItemRewards.vue';
const t = state.t.prefix('loot_crates');

export default {
  inject: ['closeModal'],
  data: () => ({
    selectedIndex: 0,
    opened: false,
    clicked: false,
    lcType: null,
    contents: [],
    error: null,
    type: null,
  }),
  components: { ItemRewards },
  computed: {
    lootCrateImage() {
      return ! this.clicked ? this.lcType?.beforeOpenImageUrl : this.lcType?.openImageUrl;
    },
    isVisible() {
      return !this.opened ? 'opacity: 1;' : 'opacity: 0;'
    },
    /**
     * Convert the loot crate contents to the item format used by the inventory.
     */
     items () {
      return this.contents.map((lcItem) => ({
        id : lcItem.id,
        uuid: lcItem.uuid,
        type: lcItem.typeName,
        name: lcItem.label,
        url: lcItem.imageUrl,
        rarity: lcItem.rarity,
        description: lcItem.description,
        variation: lcItem.variation,
        metadata: {
          quantity: lcItem.quantity,
          tokenLabel: lcItem.tokenLabel,
        }
      }));
    },
  },
  methods: {
    t,
    setLootCrateType(lcType, type) {
      this.lcType = lcType;
      this.type = type;
    },
    setContent(contents) {
      this.opened = true;
      this.clicked = true;
      this.contents = contents;
    },
  },
}
</script>
